import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { LicenseInfo } from '@mui/x-license';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { reactPlugin } from '../appInsights.ts';
import App from './App.tsx';
import './index.css';
import { createtheme } from './theme.ts';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_PRO_LICENSE_KEY ?? '');

const rootElement = document.getElementById('root')!;

const theme = createtheme(rootElement);

createRoot(rootElement).render(
  <StrictMode>
    <AppInsightsContext.Provider value={reactPlugin}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </StyledEngineProvider>
    </AppInsightsContext.Provider>
  </StrictMode>,
);
